export interface EndpointData<T> {
  nextContToken?: number | null; // Represents the next page token
  contToken?: number | null; // Represents the current page token
  data: T[];
  loading: boolean;
  error?: string;
  pagesLoaded?: number[];
}

export interface SetStateDataAction<T> {
  payload: {
    nextContToken?: number | null;
    contToken?: number | null;
    data: T[];
    pagesLoaded: number[];
  };
}

export interface SetStateErrorAction {
  payload: string;
}

export const setStateData = <T>(
  state: EndpointData<T>,
  action: SetStateDataAction<T>
) => ({
  ...state,
  nextContToken: action.payload.nextContToken,
  contToken: action.payload.contToken,
  data: action.payload.data,
  error: undefined,
  loading: false,
  pagesLoaded: action.payload.pagesLoaded,
});

export const setStateError = <T>(
  state: EndpointData<T>,
  action: SetStateErrorAction
) => ({
  ...state,
  error: action.payload,
  loading: false,
});

export const setStateLoading = <T>(
  state: EndpointData<T>,
  loading: boolean
) => ({
  ...state,
  loading,
});
